var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getBEMClasses } from '../../../helpers/cssClassesHelper';
import './Popover.css';
var TriggerWrapper = function TriggerWrapper(TriggerComponent, onClick) {
  return React.createElement(TriggerComponent, {
    onClick: onClick
  });
};
var baseClass = 'ap-popover';
var Popover = function (_React$Component) {
  _inherits(Popover, _React$Component);
  function Popover(props) {
    _classCallCheck(this, Popover);
    var _this = _possibleConstructorReturn(this, (Popover.__proto__ || Object.getPrototypeOf(Popover)).call(this, props));
    _this.componentWillUnmount = function () {
      _this.removeListeners();
    };
    _this.handleClickOutside = function (e) {
      if (_this.popupRef.contains(e.target)) {
        return;
      }
      _this.toggleShow();
    };
    _this.handleKeyDown = function (e) {
      if (e.code === 'Escape') {
        _this.toggleShow();
        e.target.blur();
      }
    };
    _this.toggleShow = function () {
      _this.setState({
        show: !_this.state.show,
        popoverLeftOffset: 0
      }, function () {
        // add offset to popover content if it is out of screen
        if (_this.state.show && _this.contentRef && _this.isOutOfScreen()) {
          var popoverLeftOffset = _this.getLeftOffset();
          _this.setState({
            popoverLeftOffset: popoverLeftOffset
          });
        }
        if (_this.state.show) {
          _this.addListeners();
        } else {
          _this.removeListeners();
        }
      });
    };
    _this.isOutOfScreen = function () {
      var rect = _this.contentRef.getBoundingClientRect();
      return rect.x + rect.width > window.innerWidth;
    };
    _this.getLeftOffset = function () {
      var rect = _this.contentRef.getBoundingClientRect();
      var scrollWidth = 17;
      var leftOffset = window.innerWidth - (rect.x + rect.width);
      var hasVerticalScroll = document.body.scrollHeight > window.innerHeight;
      return hasVerticalScroll ? leftOffset - scrollWidth : leftOffset;
    };
    _this.getBEMClasses = function () {
      var classes = [baseClass, _this.props.customClass, _this.props.isMenu && 'popover-menu'];
      return getBEMClasses(classes);
    };
    _this.popupRef = null;
    _this.contentRef = null;
    _this.state = {
      show: false,
      popoverLeftOffset: 0
    };
    return _this;
  }
  _createClass(Popover, [{
    key: 'addListeners',
    value: function addListeners() {
      document.addEventListener('click', this.handleClickOutside);
      document.addEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: 'removeListeners',
    value: function removeListeners() {
      document.removeEventListener('click', this.handleClickOutside);
      document.removeEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;
      var _props = this.props,
        trigger = _props.trigger,
        content = _props.content,
        drawArrow = _props.drawArrow;
      var show = this.state.show;
      var Trigger = TriggerWrapper(trigger, this.toggleShow);
      var bemClasses = this.getBEMClasses();
      var isVisible = bemClasses(show ? 'visible' : 'hidden');
      return React.createElement('div', {
        className: classnames('popover', bemClasses('popover')),
        ref: function ref(_ref2) {
          return _this2.popupRef = _ref2;
        }
      }, Trigger, React.createElement('div', {
        ref: function ref(_ref) {
          return _this2.contentRef = _ref;
        },
        className: isVisible + ' ' + bemClasses('content', drawArrow && 'with-arrow')
      }, show && content));
    }
  }]);
  return Popover;
}(React.Component);
Popover.propTypes = {
  trigger: PropTypes.func.isRequired,
  content: PropTypes.element.isRequired,
  drawArrow: PropTypes.bool,
  customClass: PropTypes.string
};
Popover.defaultProps = {
  drawArrow: false
};
export default Popover;